import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import _ from "lodash"
import Section from "components/layout/Section"
import BackEditDeleteButtons from "components/elements/Back_Edit_Delete_Buttons"
import HoofCareForm from "forms/Hoof_Care_Form"
import {
  MODALS_SHOW,
  MODALS_CONFIRM_DELETE,
  HOOF_CARE_DELETE,
} from "actions/types"

const INITIAL_STATE = {
  viewMode: true,
  valuesToEdit: {},
}

class ViewEntry extends Component {
  state = INITIAL_STATE

  UNSAFE_componentWillMount() {
    const { hoofCare, history, defaultRoute } = this.props
    const { id } = this.props.match.params
    const entry = hoofCare.entries.filter((item) => item._id === id)[0]
    if (!entry) return history.push(`${defaultRoute}/view_entries`)
    this.setState({
      valuesToEdit: entry,
    })
  }

  handleEditClick = () => {
    this.setState({
      viewMode: !this.state.viewMode,
    })
  }

  handleDeleteClick = () => {
    const successRoute = `${this.props.defaultRoute}/view_entries`
    this.props.dispatch({
      type: MODALS_SHOW,
      modalType: MODALS_CONFIRM_DELETE,
      modalProps: {
        type: "hoofCare",
        actionType: HOOF_CARE_DELETE,
        history: this.props.history,
        successRoute: successRoute,
        item: this.state.valuesToEdit._id,
      },
    })
  }

  renderSectionContent() {
    if (_.isEmpty(this.state.valuesToEdit)) return <div />

    return (
      <>
        <BackEditDeleteButtons
          handleEditClick={this.handleEditClick}
          handleDeleteClick={this.handleDeleteClick}
          viewMode={this.state.viewMode}
        />
        <div className="columns is-mobile is-centered">
          <div className="column is-5-desktop is-full-mobile is-6-tablet">
            <HoofCareForm
              editMode
              {...this.state}
              cancel={this.handleEditClick}
            />
          </div>
        </div>
      </>
    )
  }

  render() {
    return <Section>{this.renderSectionContent()}</Section>
  }
}

export default withRouter(ViewEntry)
